<template>
  <div class="bg bg-center" :style="'background-image: url('+bgImg+')'">
    <slot></slot>
  </div>
</template>

<script>
export default {
  data() {
    return {
      bgImg: (window.innerWidth || document.documentElement.clientWidth) > 768 ? this.pcImg : this.mobileImg,
    }
  },
  props: {
    pcImg: {
      default: '',
      type: String
    },
    mobileImg: {
      default: '',
      type: String
    }
  },
  methods: {
    myresize() {
      if ((window.innerWidth || document.documentElement.clientWidth) > 768) {
        this.bgImg = this.pcImg
      } else {
        this.bgImg = this.mobileImg
      }
    }
  },
  watch: {
    pcImg() {
      this.myresize()
    },
    mobileImg() {
      this.myresize()
    },
  },
  mounted() {
    window.addEventListener('resize', this.myresize)
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/register.scss';
@import '../../assets/css/base.scss';
  .bg {
    height: 550px;
    position: relative;
  }
  @media screen and(max-width: 768px) {
    .bg {
      height: 200px;
    }
  }
</style>